import Button from './Button'
import { t } from 'i18next'
import type React from 'react'
import { ModalDialog } from './ModalDialog'

interface ConfirmationDialogProps {
  title?: string
  message: string
  acceptText: string
  cancelText?: string
  onClose: (result: boolean) => void
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  message,
  acceptText,
  cancelText = 'ls_generic_cancel',
  onClose,
}) => {
  return (
    <ModalDialog
      open={true}
      title={title ? t(title) : undefined}
      onClose={() => onClose(false)}
      showCloseIcon={true}
      className="max-w-[447px]"
      actions={
        <>
          {cancelText && (
            <Button onClick={() => onClose(false)}>{t(cancelText)}</Button>
          )}
          <Button onClick={() => onClose(true)}>{t(acceptText)}</Button>
        </>
      }
    >
      <div
        className="text-xs"
        dangerouslySetInnerHTML={{ __html: t(message) }}
      />
    </ModalDialog>
  )
}

export default ConfirmationDialog
